import React, { useState, useEffect } from 'react';
import { Music, Piano, GraduationCap, Phone, ShoppingCart, Users, Calendar, Settings, Plus, Edit, Trash2, Save, X, LogOut, Menu } from 'lucide-react';
import { supabase } from './supabaseClient';
import { useNavigate, useLocation } from "react-router-dom";
const LoginPage = ({ onLogin, onBack }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Supabase login bằng email/password
      const { data, error } = await supabase.auth.signInWithPassword({
        email: username, // Nếu bạn lưu username là email
        password: password,
      });

      if (error) {
        alert('Đăng nhập thất bại: ' + error.message);
      } else {
        onLogin(data.user); // Trả về thông tin user cho component cha
      }
    } catch (err) {
      console.error(err);
      alert('Có lỗi xảy ra. Vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-gray-100 flex items-center justify-center p-4">
      <button
        onClick={onBack}
        className="absolute top-8 left-8 flex items-center text-gray-700 hover:text-yellow-600 font-semibold transition-all"
      >
        <span className="text-2xl mr-2">←</span> Quay Lại Trang Chủ
      </button>
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md border-2 border-yellow-400">
        <div className="text-center mb-8">
          <Music className="w-16 h-16 text-yellow-500 mx-auto mb-4" />
          <h2 className="text-3xl font-bold text-gray-800">Admin Login</h2>
          <p className="text-gray-600 mt-2">Starlit MUSIC</p>
        </div>
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-gray-700 font-semibold mb-2">Email</label>
            <input
              type="email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-yellow-500 focus:outline-none"
              placeholder="admin@example.com"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 font-semibold mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-yellow-500 focus:outline-none"
              placeholder="Mật khẩu"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 text-white font-bold py-3 rounded-lg hover:from-yellow-500 hover:to-yellow-600 transition-all transform hover:scale-105"
            disabled={loading}
          >
            {loading ? 'Đang đăng nhập...' : 'Đăng Nhập'}
          </button>
        </form>
      </div>
    </div>
  );
};
const FormModal = ({ show, onClose, activeTab, formData, setFormData, onSubmit, isEditing, db }) => {
  if (!show) return null;

  const getFormFields = () => {
    if (activeTab === 'students') {
      return [
        { name: 'name', label: 'Họ Tên', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: false },
        { name: 'phone', label: 'Số ĐT', type: 'tel', required: true },
        { name: 'course', label: 'Khóa Học', type: 'select', options: db.courses.map(c => c.name + ' - ' + c.duration), required: true },
        { name: 'start_date', label: 'Ngày Bắt Đầu', type: 'date', required: true },
        { name: 'status', label: 'Trạng Thái', type: 'select', options: ['Đang học', 'Chờ xác nhận', 'Đã hoàn thành'], required: true }
      ];
    } else if (activeTab === 'teachers') {
      return [
        { name: 'name', label: 'Họ Tên Giáo Viên', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'phone', label: 'Số Điện Thoại', type: 'tel', required: true },
        { name: 'specialty', label: 'Chuyên Môn', type: 'select', options: ['Piano', 'Đàn Tranh', 'Violin'], required: true },
        { name: 'experience', label: 'Kinh Nghiệm', type: 'text', required: true }
      ];
    } else if (activeTab === 'courses') {
      return [
        { name: 'name', label: 'Tên Khóa Học', type: 'text', required: true },
        { name: 'price', label: 'Học Phí', type: 'text', required: true },
        { name: 'duration', label: 'Thời Lượng (VD: 3 tháng)', type: 'text', required: true },
        { name: 'sessions', label: 'Số Buổi Học', type: 'number', required: true },
        { name: 'description', label: 'Mô Tả Khóa Học', type: 'textarea', required: true }
      ];
    } else if (activeTab === 'instruments') {
      return [
        { name: 'name', label: 'Tên Nhạc Cụ', type: 'text', required: true },
        { name: 'price', label: 'Giá Bán (đ)', type: 'number', required: true },
        { name: 'image', label: 'Icon/Emoji (VD: 🎹)', type: 'text', required: true },
        { name: 'stock', label: 'Số Lượng Tồn Kho', type: 'number', required: true },
        { name: 'description', label: 'Mô Tả Sản Phẩm', type: 'textarea', required: true }
      ];
    } else if (activeTab === 'schedules') {
      return [
        { name: 'student_id', label: 'Học Viên', type: 'select', options: db.students.map(s => ({ value: s.id, label: s.name })), required: true },
        { name: 'teacher_id', label: 'Giáo Viên', type: 'select', options: db.teachers.map(t => ({ value: t.id, label: t.name })), required: true },
        { name: 'course', label: 'Khóa Học', type: 'select', options: db.courses.map(c => c.name), required: true },
        { name: 'date', label: 'Ngày Học', type: 'date', required: true },
        { name: 'time', label: 'Giờ Học', type: 'time', required: true },
        { name: 'duration', label: 'Thời Lượng (VD: 60 phút)', type: 'text', required: true },
        { name: 'status', label: 'Trạng Thái', type: 'select', options: ['Đã xếp', 'Chờ xác nhận', 'Đã hoàn thành', 'Đã hủy'], required: true }
      ];
    } else if (activeTab === 'curriculum') {
      return [
        { name: 'course', label: 'Khóa Học', type: 'select', options: db.courses.map(c => c.name), required: true },
        { name: 'level', label: 'Trình Độ (VD: Cơ bản, Nâng cao)', type: 'text', required: true },
        { name: 'lessons', label: 'Nội Dung Học (mỗi dòng 1 bài)', type: 'textarea', required: true },
        { name: 'weeks', label: 'Số Tuần Học', type: 'number', required: true }
      ];
    }
    return [];
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 p-6 flex justify-between items-center sticky top-0 z-10">
          <h3 className="text-2xl font-bold text-gray-900">{isEditing ? 'Chỉnh Sửa' : 'Thêm Mới'}</h3>
          <button onClick={onClose} className="text-gray-900 hover:text-gray-700">
            <X className="w-6 h-6" />
          </button>
        </div>
        <form onSubmit={onSubmit} className="p-6 space-y-4">
          {getFormFields().map((field) => (
            <div key={field.name}>
              <label className="block text-gray-700 font-semibold mb-2">
                {field.label} {field.required && '*'}
              </label>
              {field.type === 'textarea' ? (
                <textarea
                  required={field.required}
                  value={field.name === 'lessons' && Array.isArray(formData[field.name]) ? formData[field.name].join('\n') : formData[field.name] || ''}
                  onChange={(e) => {
                    const value = field.name === 'lessons' ? e.target.value.split('\n').filter(l => l.trim()) : e.target.value;
                    setFormData({ ...formData, [field.name]: value });
                  }}
                  className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-yellow-500 focus:outline-none"
                  rows="4"
                />
              ) : field.type === 'select' ? (
                <select
                  required={field.required}
                  value={formData[field.name] || ''}
                  onChange={(e) => setFormData({ ...formData, [field.name]: field.options[0]?.value !== undefined ? parseInt(e.target.value) : e.target.value })}
                  className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-yellow-500 focus:outline-none"
                >
                  <option value="">Chọn...</option>
                  {field.options.map((opt, idx) => (
                    <option key={idx} value={opt.value || opt}>{opt.label || opt}</option>
                  ))}
                </select>
              ) : (
                <input
                  type={field.type}
                  required={field.required}
                  value={formData[field.name] || ''}
                  onChange={(e) => setFormData({ ...formData, [field.name]: field.type === 'number' ? parseInt(e.target.value) || 0 : e.target.value })}
                  className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-yellow-500 focus:outline-none"
                />
              )}
            </div>
          ))}
          <div className="flex space-x-4 pt-4">
            <button type="submit" className="flex-1 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold py-3 rounded-lg hover:from-yellow-500 hover:to-yellow-600">
              <Save className="w-5 h-5 inline mr-2" />Lưu
            </button>
            <button type="button" onClick={onClose} className="flex-1 bg-gray-300 text-gray-700 font-bold py-3 rounded-lg hover:bg-gray-400">Hủy</button>
          </div>
        </form>
      </div>
    </div>
  );
};

const StarlitMusicWebsite = () => {
  // React Router hooks
  const location = useLocation();
  const navigate = useNavigate();
  // Lấy trang hiện tại từ URL (vd: /game -> "game")
  const [currentPage, setCurrentPage] = useState(() =>
  location.pathname.replace('/', '') || 'home'
  );
  const [isAuthenticated, setIsAuthenticated] = useState(() => sessionStorage.getItem('isAuthenticated') === 'true');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Database state từ Supabase
  const [db, setDb] = useState({
    courses: [],
    instruments: [],
    students: [],
    teachers: [],
    schedules: [],
    curriculum: []
  });
  const [loading, setLoading] = useState(true);

  // Load data từ Supabase
  const loadData = async () => {
    setLoading(true);
    try {
      const [coursesRes, instrumentsRes, studentsRes, teachersRes, schedulesRes, curriculumRes] = await Promise.all([
        supabase.from('courses').select('*'),
        supabase.from('instruments').select('*'),
        supabase.from('students').select('*'),
        supabase.from('teachers').select('*'),
        supabase.from('schedules').select('*'),
        supabase.from('curriculum').select('*')
      ]);

      setDb({
        courses: coursesRes.data || [],
        instruments: instrumentsRes.data || [],
        students: studentsRes.data || [],
        teachers: teachersRes.data || [],
        schedules: schedulesRes.data || [],
        curriculum: curriculumRes.data || []
      });
    } catch (error) {
      console.error('Error loading data:', error);
      alert('Lỗi tải dữ liệu. Vui lòng kiểm tra kết nối.');
    }
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  // Mỗi khi URL đổi, cập nhật lại state
useEffect(() => {
  setCurrentPage(location.pathname.replace('/', '') || 'home');
}, [location]);

// Hàm điều hướng (thay cho window.location.hash)
const navigateTo = (page) => {
  if (page === 'home') {
    navigate('/');
  } else {
    navigate(`/${page}`);
  }
};

  useEffect(() => {
    if (isAuthenticated) {
      sessionStorage.setItem('isAuthenticated', 'true');
    } else {
      sessionStorage.removeItem('isAuthenticated');
    }
  }, [isAuthenticated]);

// CRUD functions với Supabase - UPDATED
  const addItem = async (category, item) => {
  try {
    const { data, error } = await supabase.from(category).insert([item]).select();
    if (error) throw error;
    
    // ✅ Cập nhật state ngay lập tức
    setDb(prev => ({
      ...prev,
      [category]: [...prev[category], data[0]]
    }));
    
    alert('Thêm thành công!');
  } catch (error) {
    console.error('Error adding item:', error);
    alert('Lỗi: ' + error.message);
  }
};

const updateItem = async (category, id, updatedItem) => {
  try {
    const { data, error } = await supabase
      .from(category)
      .update(updatedItem)
      .eq('id', id)
      .select();
    
    if (error) throw error;
    
    // ✅ Cập nhật state ngay lập tức
    setDb(prev => ({
      ...prev,
      [category]: prev[category].map(item => 
        item.id === id ? data[0] : item
      )
    }));
    
    alert('Cập nhật thành công!');
  } catch (error) {
    console.error('Error updating item:', error);
    alert('Lỗi: ' + error.message);
  }
};

const deleteItem = async (category, id) => {
  if (window.confirm('Bạn có chắc muốn xóa?')) {
    try {
      const { error } = await supabase.from(category).delete().eq('id', id);
      if (error) throw error;
      
      // ✅ Cập nhật state ngay lập tức
      setDb(prev => ({
        ...prev,
        [category]: prev[category].filter(item => item.id !== id)
      }));
      
      alert('Xóa thành công!');
    } catch (error) {
      console.error('Error deleting item:', error);
      alert('Lỗi: ' + error.message);
    }
  }
};

  const Header = () => (
    <header className="bg-gradient-to-r from-gray-900 via-black to-gray-900 text-white shadow-2xl sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => navigateTo('home')}>
            <Music className="w-10 h-10 text-yellow-400" />
            <div>
              <h1 className="text-2xl font-bold text-yellow-400">STARLIT MUSIC</h1>
              <p className="text-xs text-gray-300">Nơi âm nhạc tỏa sáng</p>
            </div>
          </div>
          <nav className="hidden md:flex space-x-6">
            {currentPage !== 'admin' && ['home', 'game', 'register', 'curriculum', 'instruments', 'contact'].map((page) => (
              <button key={page} onClick={() => navigateTo(page)} className={`px-4 py-2 rounded-lg font-semibold transition-all ${currentPage === page ? 'bg-yellow-400 text-black' : 'hover:bg-yellow-400 hover:text-black'}`}>
                {page === 'home' && 'Trang Chủ'}{page === 'game' && '🎮 Game'}{page === 'register' && 'Đăng Ký'}{page === 'curriculum' && 'Giáo Trình'}{page === 'instruments' && 'Nhạc Cụ'}{page === 'contact' && 'Liên Hệ'}
              </button>
            ))}
            {currentPage === 'admin' && <button onClick={() => navigateTo('home')} className="px-4 py-2 bg-gray-700 text-yellow-400 rounded-lg font-semibold hover:bg-gray-600">← Trang Chủ</button>}
            {isAuthenticated && currentPage !== 'admin' ? <button onClick={() => navigateTo('admin')} className="px-4 py-2 bg-yellow-500 text-black rounded-lg font-semibold hover:bg-yellow-600">O</button> : currentPage !== 'admin' && <button onClick={() => navigateTo('login')} className="px-4 py-2 bg-yellow-500 text-black rounded-lg font-semibold hover:bg-yellow-600">O</button>}
          </nav>
          <button className="md:hidden text-yellow-400" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}><Menu className="w-8 h-8" /></button>
        </div>
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 space-y-2">
            {['home', 'register', 'curriculum', 'instruments', 'contact'].map((page) => (
              <button key={page} onClick={() => { navigateTo(page); setMobileMenuOpen(false); }} className={`block w-full text-left px-4 py-2 rounded-lg font-semibold ${currentPage === page ? 'bg-yellow-400 text-black' : 'hover:bg-yellow-400 hover:text-black'}`}>
                {page === 'home' && 'Trang Chủ'}{page === 'register' && 'Đăng Ký'}{page === 'curriculum' && 'Giáo Trình'}{page === 'instruments' && 'Nhạc Cụ'}{page === 'contact' && 'Liên Hệ'}
              </button>
            ))}
          </nav>
        )}
      </div>
    </header>
  );

  const HomePage = () => (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-gray-50">
      {/* Hero Section - Gọn gàng, tối giản hơn */}
<section className="relative py-20 px-6 bg-gradient-to-b from-yellow-200 via-yellow-100 to-white text-center overflow-hidden animate-fadeIn">
  <style jsx>{`
    @keyframes fadeIn {
      0% { opacity: 0; transform: translateY(40px); }
      100% { opacity: 1; transform: translateY(0); }
    }
    .animate-fadeIn {
      animation: fadeIn 1s ease-out both;
    }
  `}</style>

  {/* Hiệu ứng nền mờ nhẹ */}
  <div className="absolute inset-0 bg-gradient-to-r from-yellow-300 via-transparent to-yellow-200 opacity-25 blur-xl"></div>

  <div className="relative z-10 max-w-3xl mx-auto">
    <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6 text-center tracking-tight leading-tight">
  <span className="block">Khơi Nguồn Đam Mê</span>
  <span className="block mt-3 bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 bg-clip-text text-transparent drop-shadow">
    Âm Nhạc
  </span>
</h2>

    <p className="text-base md:text-lg text-gray-700 font-medium max-w-xl mx-auto leading-relaxed">
      Trung tâm âm nhạc hàng đầu với đội ngũ giảng viên chuyên nghiệp và chương trình học chuẩn quốc tế.
    </p>
  </div>
</section>
{/* Mục quảng cáo / giảm giá khóa học – gộp 3 khóa học trong 1 khung */}
<section className="relative py-20 px-6 bg-gradient-to-b from-yellow-100 via-white to-yellow-50 overflow-hidden border-t-4 border-yellow-300 animate-fadeIn">
  <style jsx>{`
    @keyframes fadeIn {
      0% { opacity: 0; transform: translateY(50px); }
      100% { opacity: 1; transform: translateY(0); }
    }
    .animate-fadeIn {
      animation: fadeIn 1.2s ease-out both;
    }
  `}</style>

  <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/golden-fabric.png')]" />

  <div className="relative container mx-auto text-center">
    <h3 className="text-5xl font-extrabold text-gray-900 mb-8 drop-shadow-lg">🎶 Ưu Đãi Đặc Biệt Tháng Này 🎶</h3>
    <p className="text-lg text-gray-700 mb-12 max-w-3xl mx-auto leading-relaxed">
      Đăng ký ngay hôm nay để nhận <span className="text-yellow-600 font-bold">GIẢM 10%</span> cho các khóa học Piano, Violin và Đàn Tranh!
    </p>

    <div className="relative bg-white/90 backdrop-blur-sm border-2 border-yellow-300 rounded-3xl shadow-2xl max-w-5xl mx-auto p-12">
      <div className="grid md:grid-cols-3 gap-10 text-center">
        {[
          { icon: '🎹', title: 'Khóa Học Piano', desc: 'Từ cơ bản đến nâng cao, học cùng giáo viên giàu kinh nghiệm.' },
          { icon: '🎻', title: 'Khóa Học Violin', desc: 'Cải thiện kỹ năng biểu diễn và cảm thụ âm nhạc chuẩn quốc tế.' },
          { icon: '🎵', title: 'Khóa Học Đàn Tranh', desc: 'Kết hợp nghệ thuật truyền thống và hiện đại trong không gian sáng tạo.' }
        ].map((item, i) => (
          <div key={i} className="animate-fadeIn" style={{ animationDelay: `${0.3 + i * 0.2}s` }}>
            <div className="text-5xl mb-3">{item.icon}</div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h4>
            <p className="text-gray-600 text-sm leading-relaxed mb-3">{item.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-10 text-3xl font-extrabold text-yellow-600">🎁 Giảm 10% Toàn Bộ Khóa Học!</div>
    </div>

    <p className="mt-8 text-gray-500 text-sm italic">* Ưu đãi chỉ áp dụng đến hết ngày 30/07/2026.</p>
  </div>
</section>
      <section className="py-16 px-4">
        <div className="container mx-auto">
          <h3 className="text-4xl font-bold text-center mb-12 text-gray-800">Khóa Học Của Chúng Tôi</h3>
          {loading ? (
            <p className="text-center text-gray-600">Đang tải...</p>
          ) : (
            <div className="grid md:grid-cols-3 gap-8">
              {db.courses.filter((course, index, self) =>  index === self.findIndex((c) => c.name === course.name)).map((course) => (
                <div key={course.id} className="bg-white rounded-2xl shadow-xl p-8 border-2 border-yellow-400 hover:shadow-2xl transition-all transform hover:-translate-y-2">
                  <div className="text-6xl mb-4 text-center">{course.name === 'Piano' && '🎹'}{course.name === 'Đàn Tranh' && '🎵'}{course.name === 'Violin' && '🎻'}</div>
                  <h4 className="text-2xl font-bold text-gray-800 mb-4 text-center">{course.name}</h4>
                  <p className="text-gray-600 mb-4 text-center">{course.description}</p>
                  <div className="space-y-2 mb-6">
                    <p className="text-gray-700"><strong>Học phí:</strong> {course.price?.toLocaleString()}</p>
                    <p className="text-gray-700"><strong>Khóa học:</strong> {course.duration}</p>
                    
                  </div>
                  <button onClick={() => navigateTo('register')} className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold py-3 rounded-lg hover:from-yellow-500 hover:to-yellow-600 transition-all">Đăng Ký</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
      {/* Mục Luyện thi LCM */}
<section className="py-20 px-6 bg-gradient-to-r from-blue-50 via-white to-yellow-50 border-t-4 border-yellow-300">
  <div className="container mx-auto text-center">
    <h3 className="text-5xl font-extrabold text-gray-900 mb-6">🎓 Luyện Thi Chứng Chỉ Âm Nhạc Quốc Tế LCM</h3>
    <p className="text-lg text-gray-700 mb-12 max-w-3xl mx-auto leading-relaxed">
      Chương trình luyện thi <span className="font-bold text-blue-600">London College of Music (LCM)</span> –
      chuẩn đầu ra quốc tế, được công nhận toàn cầu.  
      <br />Dành cho học viên muốn thi chứng chỉ Piano, Violin, hoặc Thanh Nhạc.
    </p>

    <div className="grid md:grid-cols-3 gap-10 justify-center">
      {[
        { icon: '🎹', title: 'Piano', desc: 'Luyện thi Grade 1–8, học với giáo viên LCM được chứng nhận.' },
        { icon: '🎻', title: 'Violin', desc: 'Chương trình luyện thi chuyên sâu giúp bạn đạt điểm cao nhất.' },
        { icon: '🎤', title: 'Thanh Nhạc', desc: 'Phát triển kỹ thuật hát, phong cách và chuẩn âm quốc tế.' }
      ].map((item, i) => (
        <div key={i} className="bg-white rounded-3xl shadow-xl border border-blue-200 p-10 hover:-translate-y-2 transition-all hover:shadow-lg">
          <div className="text-6xl mb-4">{item.icon}</div>
          <h4 className="text-2xl font-bold text-gray-900 mb-3">{item.title}</h4>
          <p className="text-gray-600 mb-6 leading-relaxed">{item.desc}</p>
          <p className="text-blue-600 font-bold text-lg">📘 Chứng chỉ quốc tế LCM</p>
        </div>
      ))}
    </div>

    <button
      onClick={() => navigateTo('register')}
      className="mt-12 bg-gradient-to-r from-blue-400 to-yellow-400 text-black font-bold py-4 px-8 rounded-full shadow-md hover:shadow-lg hover:from-blue-500 hover:to-yellow-500 transform hover:scale-105 transition-all"
    >
      Đăng Ký Luyện Thi Ngay
    </button>
  </div>
</section>

      <section className="py-16 px-4 bg-gradient-to-r from-gray-900 to-black text-white">
        <div className="container mx-auto">
          <h3 className="text-4xl font-bold text-center mb-12 text-yellow-400">Tại Sao Chọn Chúng Tôi?</h3>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { icon: '👨‍🏫', title: 'Giáo viên chuyên nghiệp', desc: 'Đội ngũ giảng viên giàu kinh nghiệm' },
              { icon: '🎼', title: 'Chương trình chuẩn', desc: 'Giáo trình quốc tế được cập nhật' },
              { icon: '🏢', title: 'Cơ sở hiện đại', desc: 'Phòng học cách âm, nhạc cụ cao cấp' },
              { icon: '⭐', title: 'Học phí hợp lý', desc: 'Nhiều ưu đãi và chương trình khuyến mãi' }
            ].map((feature, idx) => (
              <div key={idx} className="text-center p-6 bg-gray-800 rounded-xl hover:bg-gray-700 transition-all">
                <div className="text-5xl mb-4">{feature.icon}</div>
                <h4 className="text-xl font-bold text-yellow-400 mb-2">{feature.title}</h4>
                <p className="text-gray-300">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
  const RegisterPage = () => {
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', course: 'Piano', message: '' });
    const [submitting, setSubmitting] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const handleSubmit = async (e) => {
      e.preventDefault();
      setSubmitting(true);
      try {
        const { error } = await supabase.from('students').insert([{
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          course: formData.course,
          start_date: new Date().toISOString().split('T')[0],
          status: 'Chờ xác nhận',
          message: formData.message
        }]);
        
        if (error) throw error;
        setShowSuccessPopup(true);
        setFormData({ name: '', email: '', phone: '', course: 'Piano', message: '' });
      } catch (error) {
        alert('Lỗi: ' + error.message);
      }
      setSubmitting(false);
    };

    return ( 
      <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-gray-50 py-12 px-4">
        {showSuccessPopup && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 animate-fadeIn">
        <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 text-center transform animate-scaleIn">
          <div className="mb-6">
            <div className="w-20 h-20 bg-gradient-to-br from-green-400 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4 animate-bounce">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h3 className="text-3xl font-bold text-gray-800 mb-3">🎉 Đăng Ký Thành Công!</h3>
            <p className="text-gray-600 text-lg leading-relaxed">
              Cảm ơn bạn đã đăng ký khóa học tại <span className="font-bold text-yellow-600">Starlit Music</span>.
              <br />
              Chúng tôi sẽ liên hệ với bạn trong thời gian sớm nhất!
            </p>
          </div>
          <button
            onClick={() => setShowSuccessPopup(false)}
            className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold py-3 px-6 rounded-xl hover:from-yellow-500 hover:to-yellow-600 transition-all transform hover:scale-105"
          >
            Đóng
          </button>
        </div>
      </div>
    )}
        <div className="container mx-auto max-w-2xl">
          <div className="bg-white rounded-2xl shadow-2xl p-8 border-2 border-yellow-400">
            <h2 className="text-4xl font-bold text-gray-800 mb-8 text-center">Đăng Ký Khóa Học</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Họ và Tên *</label>
                <input type="text" required value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-yellow-500 focus:outline-none" placeholder="Nguyễn Văn A" />
              </div>
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Email *</label>
                <input type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-yellow-500 focus:outline-none" placeholder="email@example.com (không bắt buộc)" />
              </div>
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Số Điện Thoại *</label>
                <input type="tel" required value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-yellow-500 focus:outline-none" placeholder="0901234567" />
              </div>
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Chọn Khóa Học *</label>
                <select value={formData.course} onChange={(e) => setFormData({ ...formData, course: e.target.value })} className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-yellow-500 focus:outline-none">
                  {db.courses.map((course) => (
                    <option key={course.id} value={course.name}>{course.name} - {course.duration?.toLocaleString()}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Ghi Chú</label>
                <textarea value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-yellow-500 focus:outline-none" rows="4" placeholder="Thời gian mong muốn, yêu cầu đặc biệt..." />
              </div>
              <button type="submit" disabled={submitting} className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold py-4 rounded-lg hover:from-yellow-500 hover:to-yellow-600 transition-all transform hover:scale-105 disabled:opacity-50">
                {submitting ? 'Đang gửi...' : 'Gửi Đăng Ký'}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  };

  const CurriculumPage = () => (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-gray-50 py-12 px-4">
      <div className="container mx-auto">
        <h2 className="text-4xl font-bold text-gray-800 mb-12 text-center">Giáo Trình Học</h2>
        {loading ? (
          <p className="text-center text-gray-600">Đang tải...</p>
        ) : (
          <div className="space-y-8">
            {db.curriculum.map((item) => (
              <div key={item.id} className="bg-white rounded-2xl shadow-xl p-8 border-2 border-yellow-400">
                <div className="flex items-center mb-4">
                  <GraduationCap className="w-8 h-8 text-yellow-500 mr-3" />
                  <div>
                    <h3 className="text-2xl font-bold text-gray-800">{item.course} - {item.level}</h3>
                    <p className="text-gray-600">{item.weeks} tuần</p>
                  </div>
                </div>
                <div className="bg-yellow-50 rounded-lg p-6">
                  <h4 className="font-bold text-gray-800 mb-3">Nội dung học:</h4>
                  <ul className="space-y-2">
                    {(item.lessons || []).map((lesson, idx) => (
                      <li key={idx} className="flex items-start">
                        <span className="text-yellow-500 mr-2">✓</span>
                        <span className="text-gray-700">{lesson}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
const GamePage = () => {
  const [ctx, setCtx] = useState(null);
  const [currentNote, setCurrentNote] = useState(null);
  const [gameScore, setGameScore] = useState(0);
  const [difficulty, setDifficulty] = useState('medium');
  const [status, setStatus] = useState('Chưa bắt đầu.');
  const [history, setHistory] = useState([]);
  const [timeLeft, setTimeLeft] = useState(60);
  const [gameStarted, setGameStarted] = useState(false);
  const [choices, setChoices] = useState([]);

  const NOTES = [
    { name: 'Đô', code:'C', freq:261.63 },
    { name: 'Rê', code:'D', freq:293.66 },
    { name: 'Mi', code:'E', freq:329.63 },
    { name: 'Fa', code:'F', freq:349.23 },
    { name: 'Sol', code:'G', freq:392.00 },
    { name: 'La', code:'A', freq:440.00 },
    { name: 'Si', code:'B', freq:493.88 },
    { name: 'Đô (cao)', code:'C2', freq:523.25 }
  ];

  useEffect(() => {
    if (!ctx) setCtx(new (window.AudioContext || window.webkitAudioContext)());
  }, [ctx]);

  useEffect(() => {
    let interval;
    if (gameStarted && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            setGameStarted(false);
            setStatus('⏰ Hết giờ!');
            alert(`⏰ Hết giờ! Tổng điểm: ${gameScore}`);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [gameStarted, timeLeft, gameScore]);

  const playTone = (freq, time = 700) => {
    if (!ctx) return;
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = 'sine';
    o.frequency.value = freq;
    o.connect(g);
    g.connect(ctx.destination);
    g.gain.setValueAtTime(0, ctx.currentTime);
    g.gain.linearRampToValueAtTime(0.8, ctx.currentTime + 0.02);
    o.start();
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + time/1000);
    setTimeout(() => o.stop(), time + 50);
  };

  const newNote = () => {
    const pool = difficulty === 'easy' ? [0,1,2,4] : difficulty === 'hard' ? [...Array(8).keys()] : [...Array(7).keys()];
    return NOTES[pool[Math.floor(Math.random() * pool.length)]];
  };

  const makeButtons = () => {
    const pool = difficulty === 'easy' ? [NOTES[0], NOTES[1], NOTES[2], NOTES[4]] : NOTES.slice(0, 7);
    const shuffled = [...pool].sort(() => Math.random() - 0.5);
    setChoices(shuffled);
  };

  const checkAns = (note) => {
    if (!currentNote || !gameStarted) return;
    if (note.code === currentNote.code) {
      setGameScore(prev => prev + 10);
      setStatus('Chuẩn! +10 điểm');
      setHistory(prev => [{ name: note.name, correct: true }, ...prev.slice(0, 7)]);
    } else {
      setStatus(`Sai — Đúng là ${currentNote.name}`);
      setHistory(prev => [{ name: currentNote.name, correct: false }, ...prev.slice(0, 7)]);
    }
    setCurrentNote(null);
  };

  const startGame = () => {
    setGameStarted(true);
    setGameScore(0);
    setTimeLeft(60);
    setHistory([]);
    setStatus('Bắt đầu chơi!');
    makeButtons();
    const note = newNote();
    setCurrentNote(note);
  };

  const playCurrentNote = () => {
    if (!currentNote) {
      const note = newNote();
      setCurrentNote(note);
      makeButtons();
      playTone(note.freq);
      setStatus('Đang phát nốt...');
    } else {
      playTone(currentNote.freq);
      setStatus('Đang phát nốt...');
    }
  };

  const nextNote = () => {
    const note = newNote();
    setCurrentNote(note);
    makeButtons();
    setStatus('Nốt mới sẵn sàng.');
  };

  const resetGame = () => {
    setGameScore(0);
    setHistory([]);
    setStatus('Đã đặt lại.');
  };

  useEffect(() => {
    makeButtons();
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [difficulty]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-gray-50 py-12 px-4">
      <div className="container mx-auto max-w-5xl">
        <div className="bg-white rounded-2xl shadow-2xl p-8 border-2 border-yellow-400">
          <div className="mb-6">
            <h2 className="text-4xl font-bold text-gray-800 mb-2">🎵 Game Đoán Nốt Nhạc</h2>
            <p className="text-gray-600">Nghe âm thanh phát ra và chọn đúng tên nốt: Đô, Rê, Mi, Fa, Sol, La, Si.</p>
          </div>

          <div className="bg-yellow-50 rounded-lg p-4 mb-6 flex items-center justify-between flex-wrap gap-4">
            <div className="font-bold text-lg">
              ⏱️ Thời gian: <span className="text-yellow-600">{timeLeft}s</span>
            </div>
            <button onClick={startGame} disabled={gameStarted} className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold px-6 py-2 rounded-lg hover:from-yellow-500 hover:to-yellow-600 disabled:opacity-50">
              {gameStarted ? 'Đang chơi...' : 'Bắt Đầu'}
            </button>
            <div className="font-bold text-lg">
              Điểm: <span className="text-yellow-600">{gameScore}</span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-4 mb-6">
            <div>
              <label className="block text-gray-700 font-semibold mb-2">Mức độ:</label>
              <select value={difficulty} onChange={(e) => setDifficulty(e.target.value)} disabled={gameStarted} className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-yellow-500 focus:outline-none">
                <option value="easy">Dễ (4 nốt)</option>
                <option value="medium">Trung bình (7 nốt)</option>
                <option value="hard">Khó (8 nốt)</option>
              </select>
            </div>
            <div className="flex gap-2 items-end">
              <button onClick={playCurrentNote} disabled={!gameStarted} className="flex-1 bg-blue-500 text-white font-bold px-4 py-2 rounded-lg hover:bg-blue-600 disabled:opacity-50">
                🔊 Phát Nốt
              </button>
              <button onClick={nextNote} disabled={!gameStarted} className="flex-1 bg-gray-500 text-white font-bold px-4 py-2 rounded-lg hover:bg-gray-600 disabled:opacity-50">
                ⏭️ Nốt Khác
              </button>
            </div>
            <div className="flex items-end">
              <button onClick={resetGame} className="w-full bg-red-500 text-white font-bold px-4 py-2 rounded-lg hover:bg-red-600">
                🔄 Đặt Lại
              </button>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="font-bold text-gray-800 mb-3">Chọn tên nốt:</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {choices.map((note, idx) => (
                <button
                  key={idx}
                  onClick={() => checkAns(note)}
                  disabled={!gameStarted || !currentNote}
                  className="bg-gradient-to-br from-white to-gray-50 border-2 border-gray-300 text-gray-800 font-bold py-4 px-6 rounded-xl hover:border-yellow-400 hover:shadow-lg transition-all disabled:opacity-50 text-lg"
                >
                  {note.name}
                </button>
              ))}
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-blue-50 rounded-lg p-4">
              <h4 className="font-bold text-gray-800 mb-2">📊 Trạng thái:</h4>
              <p className="text-gray-700">{status}</p>
            </div>
            <div className="bg-green-50 rounded-lg p-4">
              <h4 className="font-bold text-gray-800 mb-2">📜 Lịch sử:</h4>
              <ul className="space-y-1">
                {history.map((h, idx) => (
                  <li key={idx} className={`text-sm ${h.correct ? 'text-green-700' : 'text-red-700'}`}>
                    {h.name} — {h.correct ? '✅ Đúng' : '❌ Sai'}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-6 text-sm text-gray-500">
            💡 <strong>Phím tắt:</strong> A-G để chọn nốt | Space để phát lại | Enter để nốt khác
          </div>
        </div>
      </div>
    </div>
  );
};
  const InstrumentsPage = () => (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-gray-50 py-12 px-4">
      <div className="container mx-auto">
        <h2 className="text-4xl font-bold text-gray-800 mb-12 text-center">Nhạc Cụ Bán</h2>
        {loading ? (
          <p className="text-center text-gray-600">Đang tải...</p>
        ) : (
          <div className="grid md:grid-cols-3 gap-8">
            {db.instruments.map((instrument) => (
              <div key={instrument.id} className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-yellow-400 hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="bg-gradient-to-br from-yellow-400 to-yellow-300 p-12 text-center">
                  <div className="text-8xl">{instrument.image}</div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">{instrument.name}</h3>
                  <p className="text-gray-600 mb-4">{instrument.description}</p>
                  <div className="space-y-2 mb-4">
                    <p className="text-2xl font-bold text-yellow-600">{instrument.price?.toLocaleString()}đ</p>
                    <p className="text-gray-600">Còn lại: {instrument.stock} sản phẩm</p>
                  </div>
                  <button onClick={() => alert('Liên hệ số điện thoại: 0974 445 647')}
                    className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold py-3 rounded-lg hover:from-yellow-500 hover:to-yellow-600 transition-all">
                    <ShoppingCart className="w-5 h-5 inline mr-2" />Liên Hệ Mua Hàng
                    </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  const ContactPage = () => (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-gray-50 py-12 px-4">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-4xl font-bold text-gray-800 mb-12 text-center">Liên Hệ Với Chúng Tôi</h2>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-yellow-400">
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Thông Tin Liên Hệ</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <Phone className="w-6 h-6 text-yellow-500 mr-3 mt-1" />
                <div>
                  <p className="font-semibold text-gray-800">Điện thoại</p>
                  <p className="text-gray-600">0974 445 647</p>
                  <p className="text-gray-600"></p>
                </div>
              </div>
              <div className="flex items-start">
                <Music className="w-6 h-6 text-yellow-500 mr-3 mt-1" />
                <div>
                  <p className="font-semibold text-gray-800">Email</p>
                  <p className="text-gray-600">starlitstudio1008@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start">
                <GraduationCap className="w-6 h-6 text-yellow-500 mr-3 mt-1" />
                <div>
                  <p className="font-semibold text-gray-800">Địa chỉ</p>
                  <p className="text-gray-600">CS1:Lầu 1- 114B Trần Quang Khải, Quận 1, TP.HCM</p>
                  <p className="text-gray-600">CS2:102/53C Đường số 4, P.Tam Bình,TP.Thủ Đức, TP.HCM</p>
                </div>
              </div>
            </div>
            <div className="mt-8 pt-8 border-t-2 border-yellow-200">
              <h4 className="font-bold text-gray-800 mb-4">Giờ Làm Việc</h4>
              <p className="text-gray-600">Thứ 2 - Thứ 6: 8:00 - 20:00</p>
              <p className="text-gray-600">Thứ 7 - CN: 8:00 - 20:00</p>
            </div>
          </div>
          <div className="bg-gradient-to-br from-yellow-400 to-yellow-300 rounded-2xl shadow-xl p-8 text-center flex flex-col justify-center">
            <Music className="w-24 h-24 text-gray-900 mx-auto mb-6" />
            <h3 className="text-3xl font-bold text-gray-900 mb-4">STARLIT MUSIC</h3>
            <p className="text-gray-800 text-lg">Nơi ước mơ âm nhạc trở thành hiện thực</p>
          </div>
        </div>
      </div>
    </div>
  );

  const AdminPanel = () => {
    const [activeTab, setActiveTab] = useState(() => sessionStorage.getItem('activeTab') || 'students');
  useEffect(() => {
  sessionStorage.setItem('activeTab', activeTab);
}, [activeTab]);
    const [localShowForm, setLocalShowForm] = useState(false);
    const [localFormData, setLocalFormData] = useState({});
    const [localEditingItem, setLocalEditingItem] = useState(null);

    const handleFormSubmit = async (e) => {
      e.preventDefault();
      if (localEditingItem) {
        await updateItem(activeTab, localEditingItem.id, localFormData);
      } else {
        await addItem(activeTab, localFormData);
      }
      setLocalShowForm(false);
      setLocalFormData({});
      setLocalEditingItem(null);
    };

    const handleCloseForm = () => {
      setLocalShowForm(false);
      setLocalFormData({});
      setLocalEditingItem(null);
    };

    const DataTable = ({ category, columns, data }) => (
      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 p-4 flex justify-between items-center">
          <h3 className="text-xl font-bold text-gray-900">{category}</h3>
          <button onClick={() => { setLocalFormData({}); setLocalEditingItem(null); setLocalShowForm(true); }} className="bg-white text-yellow-600 px-4 py-2 rounded-lg font-semibold hover:bg-gray-100 flex items-center">
            <Plus className="w-4 h-4 mr-2" />Thêm Mới
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-100">
              <tr>
                {columns.map((col) => (
                  <th key={col.key} className="px-4 py-3 text-left text-gray-700 font-semibold">{col.label}</th>
                ))}
                <th className="px-4 py-3 text-center text-gray-700 font-semibold">Hành Động</th>
              </tr>
            </thead>
            <tbody>
              {[...data].sort((a, b) => a.id - b.id).map((item) => (
                <tr key={item.id} className="border-b hover:bg-gray-50">
                  {columns.map((col) => (
                    <td key={col.key} className="px-4 py-3 text-gray-700">
                      {col.render ? col.render(item[col.key], item) : item[col.key]}
                    </td>
                  ))}
                  <td className="px-4 py-3 text-center">
                    <button onClick={() => { setLocalEditingItem(item); setLocalFormData(item); setLocalShowForm(true); }} className="text-blue-600 hover:text-blue-800 mr-3">
                      <Edit className="w-5 h-5 inline" />
                    </button>
                    <button onClick={() => deleteItem(activeTab, item.id)} className="text-red-600 hover:text-red-800">
                      <Trash2 className="w-5 h-5 inline" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );

    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 py-8 px-4">
        <div className="container mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden mb-8">
            <div className="bg-gradient-to-r from-gray-900 to-black p-6 flex justify-between items-center">
              <div className="flex items-center">
                <Settings className="w-8 h-8 text-yellow-400 mr-3" />
                <h2 className="text-3xl font-bold text-yellow-400">Admin Panel</h2>
              </div>
              <button onClick={() => { setIsAuthenticated(false); navigateTo('home'); }} className="bg-red-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-red-600 flex items-center">
                <LogOut className="w-4 h-4 mr-2" />Đăng Xuất
              </button>
            </div>
            <div className="flex flex-wrap border-b">
              {[
                { key: 'students', label: 'Học Viên', icon: Users },
                { key: 'teachers', label: 'Giáo Viên', icon: GraduationCap },
                { key: 'schedules', label: 'Lịch Học', icon: Calendar },
                { key: 'courses', label: 'Khóa Học', icon: Music },
                { key: 'instruments', label: 'Nhạc Cụ', icon: Piano },
                { key: 'curriculum', label: 'Giáo Trình', icon: GraduationCap }
              ].map((tab) => (
                <button key={tab.key} onClick={() => setActiveTab(tab.key)} className={`flex items-center px-6 py-4 font-semibold transition-all ${activeTab === tab.key ? 'bg-yellow-400 text-black border-b-4 border-yellow-600' : 'text-gray-600 hover:bg-gray-100'}`}>
                  <tab.icon className="w-5 h-5 mr-2" />{tab.label}
                </button>
              ))}
            </div>
          </div>

          {loading ? (
            <p className="text-center text-gray-600">Đang tải...</p>
          ) : (
            <>
              {activeTab === 'students' && (
                <DataTable category="Quản Lý Học Viên" columns={[
                  { key: 'id', label: 'ID' },
                  { key: 'name', label: 'Họ Tên' },
                  { key: 'email', label: 'Email' },
                  { key: 'phone', label: 'Số ĐT' },
                  { key: 'course', label: 'Khóa Học' },
                  { key: 'start_date', label: 'Ngày BĐ' },
                  { key: 'status', label: 'Trạng Thái', render: (val) => (
                    <span className={`px-3 py-1 rounded-full text-sm font-semibold ${val === 'Đang học' ? 'bg-green-100 text-green-700' : val === 'Chờ xác nhận' ? 'bg-yellow-100 text-yellow-700' : 'bg-gray-100 text-gray-700'}`}>{val}</span>
                  )}
                ]} data={db.students} />
              )}

              {activeTab === 'teachers' && (
                <DataTable category="Quản Lý Giáo Viên" columns={[
                  { key: 'id', label: 'ID' },
                  { key: 'name', label: 'Họ Tên' },
                  { key: 'email', label: 'Email' },
                  { key: 'phone', label: 'Số ĐT' },
                  { key: 'specialty', label: 'Chuyên Môn' },
                  { key: 'experience', label: 'Kinh Nghiệm' }
                ]} data={db.teachers} />
              )}

              {activeTab === 'schedules' && (
                <DataTable category="Quản Lý Lịch Học" columns={[
                  { key: 'id', label: 'ID' },
                  { key: 'student_id', label: 'Học Viên', render: (val) => db.students.find(s => s.id === val)?.name || 'N/A' },
                  { key: 'teacher_id', label: 'Giáo Viên', render: (val) => db.teachers.find(t => t.id === val)?.name || 'N/A' },
                  { key: 'course', label: 'Khóa Học' },
                  { key: 'date', label: 'Ngày' },
                  { key: 'time', label: 'Giờ' },
                  { key: 'duration', label: 'Thời Lượng' },
                  { key: 'status', label: 'Trạng Thái' }
                ]} data={db.schedules} />
              )}

              {activeTab === 'courses' && (
                <DataTable category="Quản Lý Khóa Học" columns={[
                  { key: 'id', label: 'ID' },
                  { key: 'name', label: 'Tên Khóa' },
                  { key: 'price', label: 'Học Phí', render: (val) => `${val?.toLocaleString()}` },
                  { key: 'duration', label: 'Thời Lượng' },
                  
                  { key: 'description', label: 'Mô Tả' }
                ]} data={db.courses} />
              )}

              {activeTab === 'instruments' && (
                <DataTable category="Quản Lý Nhạc Cụ" columns={[
                  { key: 'id', label: 'ID' },
                  { key: 'name', label: 'Tên SP' },
                  { key: 'price', label: 'Giá', render: (val) => `${val?.toLocaleString()}đ` },
                  { key: 'image', label: 'Icon' },
                  { key: 'stock', label: 'Tồn Kho' },
                  { key: 'description', label: 'Mô Tả' }
                ]} data={db.instruments} />
              )}

              {activeTab === 'curriculum' && (
                <DataTable category="Quản Lý Giáo Trình" columns={[
                  { key: 'id', label: 'ID' },
                  { key: 'course', label: 'Khóa Học' },
                  { key: 'level', label: 'Trình Độ' },
                  { key: 'weeks', label: 'Số Tuần' },
                  { key: 'lessons', label: 'Nội Dung', render: (val) => `${val?.length || 0} bài học` }
                ]} data={db.curriculum} />
              )}
            </>
          )}

          <FormModal 
            show={localShowForm}
            onClose={handleCloseForm}
            activeTab={activeTab}
            formData={localFormData}
            setFormData={setLocalFormData}
            onSubmit={handleFormSubmit}
            isEditing={!!localEditingItem}
            db={db}
          />
        </div>
      </div>
    );
  };

  if (currentPage === 'login') {
    return <LoginPage onLogin={(role) => { setIsAuthenticated(true); navigateTo('admin'); }} onBack={() => navigateTo('home')} />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      {currentPage === 'home' && <HomePage />}
      {currentPage === 'game' && <GamePage />}
      {currentPage === 'register' && <RegisterPage />}
      {currentPage === 'curriculum' && <CurriculumPage />}
      {currentPage === 'instruments' && <InstrumentsPage />}
      {currentPage === 'contact' && <ContactPage />}
      {currentPage === 'admin' && isAuthenticated && <AdminPanel />}
      <footer className="bg-gradient-to-r from-gray-900 via-black to-gray-900 text-white py-12 px-4">
        <div className="container mx-auto text-center">
          <Music className="w-12 h-12 text-yellow-400 mx-auto mb-4" />
          <h3 className="text-2xl font-bold text-yellow-400 mb-2">STARLIT MUSIC</h3>
          <p className="text-gray-300 mb-4">Nơi âm nhạc tỏa sáng</p>
          <p className="text-gray-400 text-sm">© 2025 Starlit MUSIC. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default StarlitMusicWebsite;
